// Allways return to top of page
exports.shouldUpdateScroll = () => {
  window.scrollTo(0, 0); return false;
};